"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DownloadPrintButton = exports.MenuButton = exports.SingleApplication = exports.LandingPage = exports.UploadMultipleFiles = exports.TaskStatusComponents = exports.TaskDialog = exports.Table = exports.Tooltip = exports.CustomTab = exports.RadioGroup = exports.MultiDownloadCard = exports.FeesEstimateCard = exports.DocumentList = exports.TooltipWithChildren = exports.StepperStaticVerticalWithTab = exports.TextfieldWithIcon = exports.StepperStaticVertical = exports.Stepper = exports.AppSubOption = exports.AppCarosel = exports.AppCards = exports.AppCard = exports.CommonView = exports.LoadingIndicator = exports.AppliedRoute = exports.RenderScreen = exports.CardWithMedia = exports.StepperNonLinearWithoutAction = exports.ComponentInterface = exports.Map = exports.RenderRoutes = undefined;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactLoadable = require("react-loadable");

var _reactLoadable2 = _interopRequireDefault(_reactLoadable);

var _LinearSpinner = require("../ui-atoms/LinearSpinner");

var _LinearSpinner2 = _interopRequireDefault(_LinearSpinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Loading = function Loading() {
  return _react2.default.createElement(_LinearSpinner2.default, null);
};
var RenderRoutes = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("./RenderRoutes");
  },
  loading: function loading() {
    return _react2.default.createElement(Loading, null);
  }
});
var Map = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("./Map");
  },
  loading: function loading() {
    return _react2.default.createElement(Loading, null);
  }
});
var ComponentInterface = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("./ComponentInterface");
  },
  loading: function loading() {
    return _react2.default.createElement(Loading, null);
  }
});
var StepperNonLinearWithoutAction = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("./StepperNonLinearWithoutAction");
  },
  loading: function loading() {
    return _react2.default.createElement(Loading, null);
  }
});
var CardWithMedia = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("./CardWithMedia");
  },
  loading: function loading() {
    return _react2.default.createElement(Loading, null);
  }
});
var RenderScreen = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("./RenderScreen");
  },
  loading: function loading() {
    return _react2.default.createElement(Loading, null);
  }
});
var AppliedRoute = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("./AppliedRoute");
  },
  loading: function loading() {
    return _react2.default.createElement(Loading, null);
  }
});
var LoadingIndicator = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("./LoadingIndicator");
  },
  loading: function loading() {
    return _react2.default.createElement(Loading, null);
  }
});
var CommonView = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("./CommonView");
  },
  loading: function loading() {
    return _react2.default.createElement(Loading, null);
  }
});

var AppCard = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("./AppCard");
  },
  loading: function loading() {
    return _react2.default.createElement(Loading, null);
  }
});

var AppCards = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("./AppCards");
  },
  loading: function loading() {
    return _react2.default.createElement(Loading, null);
  }
});

var AppCarosel = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("./AppCarosel");
  },
  loading: function loading() {
    return _react2.default.createElement(Loading, null);
  }
});

var AppSubOption = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("./AppSubOption");
  },
  loading: function loading() {
    return _react2.default.createElement(Loading, null);
  }
});

var Stepper = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("./Stepper");
  },
  loading: function loading() {
    return _react2.default.createElement(Loading, null);
  }
});

// const Carousel = Loadable({
//   loader: () => import("./Carousel"),
//   loading: () => <Loading />
// });

var StepperStaticVertical = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("./StepperStaticVertical");
  },
  loading: function loading() {
    return _react2.default.createElement(Loading, null);
  }
});

var TextfieldWithIcon = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("./TextfieldWithIcon");
  },
  loading: function loading() {
    return _react2.default.createElement(Loading, null);
  }
});

var StepperStaticVerticalWithTab = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("./StepperStaticVerticalWithTab");
  },
  loading: function loading() {
    return _react2.default.createElement(Loading, null);
  }
});

var TooltipWithChildren = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("./TooltipWithChildren");
  },
  loading: function loading() {
    return _react2.default.createElement(Loading, null);
  }
});

var DocumentList = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("./DocumentList");
  },
  loading: function loading() {
    return _react2.default.createElement(Loading, null);
  }
});

var FeesEstimateCard = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("./FeesEstimateCard");
  },
  loading: function loading() {
    return _react2.default.createElement(Loading, null);
  }
});

var MultiDownloadCard = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("./MultiDownloadCard");
  },
  loading: function loading() {
    return _react2.default.createElement(Loading, null);
  }
});

var RadioGroup = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("./RadioGroup");
  },
  loading: function loading() {
    return _react2.default.createElement(Loading, null);
  }
});

var CustomTab = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("./CustomTab");
  },
  loading: function loading() {
    return _react2.default.createElement(Loading, null);
  }
});

var Tooltip = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("./Tooltip");
  },
  loading: function loading() {
    return _react2.default.createElement(Loading, null);
  }
});

var TaskDialog = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("./TaskDialog");
  },
  loading: function loading() {
    return _react2.default.createElement(Loading, null);
  }
});

var TaskStatusComponents = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("./TaskStatusComponents");
  },
  loading: function loading() {
    return _react2.default.createElement(Loading, null);
  }
});
var UploadMultipleFiles = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("./UploadMultipleFiles");
  },
  loading: function loading() {
    return _react2.default.createElement(Loading, null);
  }
});

var Table = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("./Table");
  },
  loading: function loading() {
    return _react2.default.createElement(Loading, null);
  }
});

var LandingPage = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("./LandingPage");
  },
  loading: function loading() {
    return _react2.default.createElement(Loading, null);
  }
});

var SingleApplication = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("./SingleApplication");
  },
  loading: function loading() {
    return _react2.default.createElement(Loading, null);
  }
});

var MenuButton = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("./MenuButton");
  },
  loading: function loading() {
    return _react2.default.createElement(Loading, null);
  }
});

var DownloadPrintButton = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("./DownloadPrintButton");
  },
  loading: function loading() {
    return _react2.default.createElement(Loading, null);
  }
});

exports.RenderRoutes = RenderRoutes;
exports.Map = Map;
exports.ComponentInterface = ComponentInterface;
exports.StepperNonLinearWithoutAction = StepperNonLinearWithoutAction;
exports.CardWithMedia = CardWithMedia;
exports.RenderScreen = RenderScreen;
exports.AppliedRoute = AppliedRoute;
exports.LoadingIndicator = LoadingIndicator;
exports.CommonView = CommonView;
exports.AppCard = AppCard;
exports.AppCards = AppCards;
exports.AppCarosel = AppCarosel;
exports.AppSubOption = AppSubOption;
exports.Stepper = Stepper;
exports.StepperStaticVertical = StepperStaticVertical;
exports.TextfieldWithIcon = TextfieldWithIcon;
exports.StepperStaticVerticalWithTab = StepperStaticVerticalWithTab;
exports.TooltipWithChildren = TooltipWithChildren;
exports.DocumentList = DocumentList;
exports.FeesEstimateCard = FeesEstimateCard;
exports.MultiDownloadCard = MultiDownloadCard;
exports.RadioGroup = RadioGroup;
exports.CustomTab = CustomTab;
exports.Tooltip = Tooltip;
exports.Table = Table;
exports.TaskDialog = TaskDialog;
exports.TaskStatusComponents = TaskStatusComponents;
exports.UploadMultipleFiles = UploadMultipleFiles;
exports.LandingPage = LandingPage;
exports.SingleApplication = SingleApplication;
exports.MenuButton = MenuButton;
exports.DownloadPrintButton = DownloadPrintButton;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-framework/ui-molecules/index.js
// module id = ../lib/egov-ui-framework/ui-molecules/index.js
// module chunks = 504